import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import checkCircleGreen from '@eti/assets/icons/check-circle-green.svg?url'; // eslint-disable-line import/no-unresolved
import crossCircleBlack from '@eti/assets/icons/cross-circle-black.svg?url'; // eslint-disable-line import/no-unresolved
import type { TicketType } from '../../../model';
import { TICKET_TYPES } from '../../../constants';

const ticketInformationWrapperStyles = (backgroundImage: string, ticketVersion: number) => css`
  font-size: 0.875rem;
  line-height: 21px;

  ul {
    li {
      margin-bottom: 8px;
      padding-inline-start: 36px;
      position: relative;
      ${ticketVersion === 3 &&
      css`
        z-index: -1;
      `}

      &::before {
        content: '';
        height: 20px;
        inset-inline-start: 0;
        margin-inline-end: 8px;
        position: absolute;
        top: 2px;
        width: 20px;
        ${`background: url(${backgroundImage}) 0% 0% / contain
          no-repeat`};
      }
    }
  }
`;

interface TicketInformationProps {
  ticketType: TicketType;
  ticketVersion: number;
}
export const TicketInformation = ({ ticketType, ticketVersion }: TicketInformationProps) => {
  const { t } = useTranslation();

  let backgroundImage: string;
  let ticketAdditionalInformation: string;
  const { CANCEL_FOR_ANY_REASON_TICKET, FLEXIBLE_TICKET } = TICKET_TYPES;
  switch (ticketType) {
    case CANCEL_FOR_ANY_REASON_TICKET:
      backgroundImage = checkCircleGreen;
      ticketAdditionalInformation = t('Result.Page.CancelForAnyReasonTicket.Description.Text');
      break;
    case FLEXIBLE_TICKET:
      backgroundImage = checkCircleGreen;
      ticketAdditionalInformation = t('Result.Page.FlexibleTicket.Description.Text');
      break;
    default:
      backgroundImage = crossCircleBlack;
      ticketAdditionalInformation = t('Result.Page.StandardTicket.Abstract');
      break;
  }

  return (
    <div className={ticketInformationWrapperStyles(backgroundImage, ticketVersion)}>
      <DangerousHtmlContent content={ticketAdditionalInformation} />
    </div>
  );
};
